import React, { Component, Fragment } from 'react'

import Label from '../../../components/atoms/Label';
import TextBox from '../../../components/atoms/TextBox';
import Button from '../../../components/atoms/Button';

import checkFormInput from '../../../utils/helpers/checkFormInput';
import {checkPhoneNumber} from '../../../utils/constants/typeCheckFormInput'


class StepNoPonsel extends Component {
    constructor(props){
        super(props)

        this.state = {
            noponsel : {
                value : '62',
                type : checkPhoneNumber,
                isError : false,
                msg : ''
            }
        }
    }

    updateState = ({name, value}) => {
        this.setState({
            [name] :  {
                ...this.state[name],
                ...checkFormInput(value, this.state[name].type)
            }
        });
    }

    submitNoPonsel = () => {
        const {RegisterNoPonsel, onSubmit} = this.props;
        
        RegisterNoPonsel(this.state.noponsel.value).then((result)=>{
            if(result){
                onSubmit(1)
            }else{
                this.setState({
                    noponsel : {
                        ...this.state.noponsel,
                        isError : true,
                        msg : this.props.status.error
                    }
                })
            }
        })
    }

    render() {
        const {noponsel} = this.state;
        return (
            <Fragment>
                <div className='form-regisiter'>
                    <div className='form-group full-width mt-2 mr-auto ml-auto'>
                        <Label type='label' for='noponsel' value='Masukan nomor ponsel' className='label-kc-s require' />
                        <TextBox opts={{maxLength : 14}} name='noponsel' className='mt-2' value={noponsel.value} type='text' onChange={(e) => this.updateState(e.target)} isError={noponsel.isError} isFullWidth={true} />
                        <Label type='note' className='mt-2 red' value={noponsel.msg} />
                    </div>
                </div>

                <Button  type='submit' title='KIRIM KODE OTP' isDisabled={noponsel.isError} loading={this.props.status.loading} onClick={this.submitNoPonsel} color='blue' width='block'/>
            </Fragment>
        )
    }
}

export default StepNoPonsel;